import { SVGProps } from '@components/Icon/types';

export const CodeReviewComments = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 2.5)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8662 0C18.57 0 20 1.31154 20 2.95933V12.1147C20 13.7625 18.5695 15.0731 16.8662 15.0731H10.1141L5.55792 18.7355C5.15882 19.0561 4.64125 19.0643 4.22839 18.8723C3.81554 18.6802 3.49455 18.2816 3.49449 17.775V15.0731H3.13382C1.43002 15.0731 0 13.7625 0 12.1147V2.95933C0 1.31154 1.43002 0 3.13382 0H16.8662ZM3.13382 1.33954C2.12749 1.33954 1.36241 2.07953 1.36241 2.95933V12.1147C1.36241 12.9945 2.12749 13.7345 3.13382 13.7345H4.17521C4.35592 13.7345 4.52992 13.8047 4.65771 13.9302C4.7855 14.0558 4.85688 14.2267 4.85689 14.4043V17.5698L9.43918 13.8865C9.5608 13.7886 9.71318 13.7347 9.87043 13.7345H16.8662C17.8718 13.7345 18.6376 12.9945 18.6376 12.1147V7.63535C18.6272 7.56841 18.6272 7.49994 18.6376 7.433V2.95933C18.6376 2.07953 17.8725 1.33954 16.8662 1.33954H3.13382Z"
        fill={fill}
      />
      <path
        d="M8.50995 5.50691C8.78062 5.24097 8.78062 4.80952 8.50995 4.54358C8.23928 4.27764 7.80015 4.27764 7.52948 4.54358L5.05414 6.97565C4.78347 7.24159 4.78347 7.67304 5.05414 7.93897L7.52948 10.371C7.80015 10.637 8.23928 10.637 8.50995 10.371C8.78062 10.1051 8.78062 9.67365 8.50995 9.40772L6.52484 7.45731L8.50995 5.50691Z"
        fill={fill}
      />
      <path
        d="M11.49 9.40773C11.2194 9.67367 11.2194 10.1051 11.49 10.3711C11.7607 10.637 12.1998 10.637 12.4705 10.3711L14.9458 7.93899C15.2165 7.67305 15.2165 7.2416 14.9458 6.97566L12.4705 4.5436C12.1998 4.27766 11.7607 4.27766 11.49 4.5436C11.2194 4.80954 11.2194 5.24099 11.49 5.50692L13.4751 7.45733L11.49 9.40773Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'code-review-comments';
